import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import OrderWindow from './OrderWindow';
import { sortBy } from '../util/lodash';

const MIN_THRESHOLD = 5;
const MAX_THRESHOLD = 10;

const getTextFormatClass = code => {
  switch (code) {
    case '1':
      return 'veryUrgent';
    case '2':
      return 'urgent';
    default:
      return '';
  }
};

const buildSegmentCategory = name => (
  <div key={name} className='segmentCategory'>
    {name}
  </div>
);
const buildSegment = (name, textFormatCode) => (
  <div key={name} className={classnames('segment', getTextFormatClass(textFormatCode))}>
    {name}
  </div>
);

class DeadlineDetails extends Component {
  // TODO: This should not need to be here. Parent component is causing a CRAP ton of re-renders
  shouldComponentUpdate(nextProps) {
    return nextProps !== this.props;
  }

  buildSegments() {
    const {
      deadline: { details }
    } = this.props;
    let index = 0;
    const segmentNames = [];
    const segments = [];
    const columns = [];
    const sortedDetails = sortBy(details, 'segmentName');

    sortedDetails.forEach(detail => {
      const { deadlineName, segmentName, textFormatCode } = detail;
      if (!segmentNames.includes(segmentName)) {
        segmentNames.push(segmentName);
        segments.push(buildSegmentCategory(segmentName));
      }

      segments.push(buildSegment(deadlineName, textFormatCode));
    });

    // eslint-disable-next-line no-nested-ternary
    const numColumns = segments.length < MIN_THRESHOLD ? 1 : segments.length < MAX_THRESHOLD ? 2 : 3;
    const segmentsPerColumn = Math.ceil(segments.length / numColumns);

    for (let c = 0; c < 3; c++) {
      const deadlines = [];

      for (let d = 0; d < segmentsPerColumn; d++) {
        deadlines.push(segments[index]);
        index += 1;
      }

      columns.push(
        <div key={c} className='column'>
          {deadlines}
        </div>
      );
    }

    return columns;
  }

  render() {
    const { deadline } = this.props;
    if (!deadline || (deadline instanceof OrderWindow && deadline.isExpired())) return null;

    return <div className='DeadlineDetails'>{this.buildSegments()}</div>;
  }
}

DeadlineDetails.defaultProps = {
  deadline: null
};

DeadlineDetails.propTypes = {
  deadline: PropTypes.instanceOf(OrderWindow)
};

export default DeadlineDetails;
